import { TotemIconId } from '@meilleurtaux/mtp-uikit-core';
import { MtxButton, MtxIcon } from '@meilleurtaux/mtp-uikit-react';

import { BREAKPOINTS } from '@/constants/breakpoints';
import useScreenSize from '@/hooks/useScreenSize';
import { TRACKING_INSTANCE } from '@/hooks/useTracking/useTrackingInit/useTrackingInit';

import styles from './styles.module.css';

type TunnelResultPageProps = {
  iconName: TotemIconId;
  iconVariant: 'success' | 'error';
  title: string;
  subtitles?: string[];
  ctaLabel: string;
  onCtaClick: () => void;
  secondaryCtaLabel?: string;
  onSecondaryCtaClick?: () => void;
};

const TunnelResultPage = ({
  iconName,
  iconVariant,
  title,
  subtitles,
  ctaLabel,
  onCtaClick,
  secondaryCtaLabel,
  onSecondaryCtaClick,
}: TunnelResultPageProps) => {
  const { windowWidth } = useScreenSize();
  const isMobile = windowWidth <= BREAKPOINTS.mobile;

  return (
    <div className={styles.page}>
      <div className={styles.content}>
        <div className={styles[`icon-${iconVariant}`]}>
          <MtxIcon name={iconName} size={100} />
        </div>

        <div className={styles.textBtn}>
          <div className={styles.textBox}>
            <p className={styles.title}>{title}</p>

            {subtitles?.map((subtitle) => (
              <p key={subtitle} className={styles.subtitle}>
                {subtitle}
              </p>
            ))}
          </div>

          {secondaryCtaLabel && onSecondaryCtaClick ? (
            <div className={styles.buttons}>
              <MtxButton
                className="card-button-chat-indisponible"
                size="medium"
                full-width={isMobile}
                onClick={() => {
                  void TRACKING_INSTANCE.triggerEvent('clic', undefined, {
                    event_id: 'clic',
                    event_categorie: 'clic',
                    event_metier: 'placement',
                    event_nom: 'contacter_mon_conseiller',
                  });
                }}
                variant="tertiary"
              >
                <div className={styles.textButtonHelp}>{secondaryCtaLabel}</div>
              </MtxButton>
              <MtxButton
                className="card-button-chat-disponible"
                style={{ display: 'none' }}
                size="medium"
                full-width={isMobile}
                onClick={() => {
                  void TRACKING_INSTANCE.triggerEvent('clic', undefined, {
                    event_id: 'clic',
                    event_categorie: 'clic',
                    event_metier: 'placement',
                    event_nom: 'contacter_mon_conseiller',
                  });
                }}
                variant="tertiary"
              >
                <div className={styles.textButtonHelp}>{secondaryCtaLabel}</div>
              </MtxButton>
              <MtxButton
                variant="primary"
                size="medium"
                full-width={isMobile}
                onClick={() => {
                  void TRACKING_INSTANCE.triggerEvent('clic', undefined, {
                    event_id: 'clic',
                    event_categorie: 'clic',
                    event_metier: 'placement',
                    event_nom: 'voir_mon_contrat',
                  });
                  onCtaClick();
                }}
              >
                {ctaLabel}
              </MtxButton>
            </div>
          ) : (
            <MtxButton
              variant="primary"
              size="medium"
              full-width={isMobile}
              onClick={() => {
                void TRACKING_INSTANCE.triggerEvent('clic', undefined, {
                  event_id: 'clic',
                  event_categorie: 'clic',
                  event_metier: 'placement',
                  event_nom: 'voir_mon_contrat',
                });
                onCtaClick();
              }}
            >
              {ctaLabel}
            </MtxButton>
          )}
        </div>
      </div>
    </div>
  );
};

export default TunnelResultPage;
